import React, { useState, useEffect } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import FooterWithContent from "../../components/StaticComp/Footer/FooterWithContent";

export default function AmlKyc() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  return (
    <div>
      <div className={classes.root}>
        <Box className={classes.partition}>
          <Typography variant="body1">
            <p>
              We believe in following our Nations regulation regarding every
              business, although RBI has not set any regulations for Bitcoins as
              of now but we are self-regulating and we follow certain Indian
              Bitcoin Industry Standard Customer Identification Procedures for
              opening of accounts and monitoring transactions of a suspicious
              nature for the purpose of reporting it to appropriate authorities.
              We are committed to ensure that our website or services are not
              used to facilitate money laundering or the funding of terrorism or
              any other criminal activities. To fulfill this goal, we are in the
              process of designing our very own know-your-customer/KYC and
              anti-money laundering/AML Policy to safeguard our customers, as of
              now we are using policies of already established Bitcoin
              Business’s, which will be updated in a timely manner.
            </p>
            <p>
              As a part of identification procedure, we need to obtain certain
              customer identification documents including a copy of PAN card and
              address proof from every customer. These processes make us know
              who are paying us money and whom we are sending money, without
              which our website and services can be used for money laundering
              and other illicit purposes.
            </p>
            <p>
              PocketBits.in adopts the following Know Your Customer and
              Anti-Money Laundering Policy (hereinafter referred to as “KYC and
              AML Policy”) to ensure that PocketBits.in and any future platforms
              that we might support, are not used to facilitate money laundering
              or the funding of terrorism or any other criminal activities.
            </p>
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography
            id="applicable"
            variant="h3"
            className={classes.subHeading}
          >
            Purpose
          </Typography>
          <Typography variant="body1">
            <p>
              This policy is applicable on all the present as well as
              prospective Members who uses or wishes to use PocketBits.in
              through proper registration. It lays down the procedure that we
              follow to collect information and maintaining a record of our
              Members. It is the duty of Member to comply with this KYC and AML
              Policy in order to ensure that it does not abuse the relationship
              with PocketBits.in for any illegal purposes, including money
              laundering or other financial crimes. Any action, including those
              that might not have been foreseen and included in this policy,
              that has the effect of the abuse as contemplated above shall be
              restricted under this policy.
            </p>
            <p>
              Pocketbits.in reserves the right to decline business proposal, at
              its discretion, with present as well as prospective Members at all
              times. It is the discretion of Pocketbits to suspend or terminate
              any action in favor of the Member until a reasonable and
              satisfactory explanation with supporting documents is provided, on
              suspicion of the Member abusing the relationship as contemplated
              above.
            </p>
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Customer Identification
          </Typography>
          <Typography variant="body1">
            PocketBits.in collects the following basic information from its
            customers for its records:
          </Typography>
          <ul class="myUl">
            <li>
              <Typography variant="body1">To process transactions,</Typography>
            </li>
            <li>
              <Typography variant="body1">Residential Address</Typography>
            </li>
            <li>
              <Typography variant="body1">Contact Number</Typography>
            </li>
            <li>
              <Typography variant="body1">Email Address</Typography>
            </li>
            <li>
              <Typography variant="body1">
                Picture of Permanent Account Number (PAN) Card
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Picture of Proof of Address(Passport, Driver’s License etc)
              </Typography>
            </li>
            <li>
              <Typography variant="body1">Bank Details</Typography>
            </li>
            <li>
              <Typography variant="body1">Last Name</Typography>
            </li>
            <li>
              <Typography variant="body1">First Name</Typography>
            </li>
          </ul>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Measures for implementation of KYC and AML policy
          </Typography>
          <Typography variant="body1">
            PocketBits.in appoints a competent and qualified employee as an AML
            and KYC Policy Compliance Person who reviews and updates the KYC and
            AML Policy to ensure the compliance with all relevant and applicable
            legislation, regulations and recommendations and monitor compliance
            of KYC and AML Policy. PocketBits employees would be trained to
            identify and take action on suspicious transactions through
            PocketBits.in and make regular internal reports on such suspicious
            transactions. PocketBits.in would regularly inspect the transactions
            done through its Services and would report them to relevant
            supervisory and/or law enforcement authorities. PocketBits.in
            reserves the right to determine suspicious and unusual transactions
            that result into abuse of relationship with PocketBits.
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Changes to KYC and AML Policy
          </Typography>
          <Typography variant="body1">
            PocketBits.in reserves the right to change, amend, alter or delete
            some or all parts of this KYC and AML Policy, include new procedure
            and exclude existing procedures in this KYC and AML Policy. It is
            the duty of the Member to keep updated and comply at all times with
            the KYC and AML Policy as and when updated on the Website.
          </Typography>
        </Box>
      </div>
      <FooterWithContent />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    color: "#fff",
    width: "70%",
    margin: "0 auto",
    marginTop: "100px",
  },
  subHeading: {
    paddingBottom: "20px",
    textTransform: "capitalize",
  },
  partition: {
    paddingBottom: "20px",
  },
}));
